
import React from 'react'
import { BaseNode } from '../base'
import { NODE_DEFAULTS } from '@genieartinc/schemas'
import type { NodeProps } from '../types'

/** Purpose-to-config key mapping for AI image node variants */
const PURPOSE_CONFIG_KEY: Record<string, string> = {
  create: 'image-create',
  edit: 'image-edit',
  enhance: 'image-enhance',
  tools: 'image-utils',
}

/** Purpose-specific input requirements */
const PURPOSE_REQUIREMENTS: Record<string, { promptRequired: boolean; imageRequired: boolean }> = {
  create: { promptRequired: true, imageRequired: false },
  edit: { promptRequired: true, imageRequired: true },
  enhance: { promptRequired: false, imageRequired: true },
  tools: { promptRequired: false, imageRequired: true },
}

export function ImageNode({ purpose, ...props }: Omit<NodeProps, 'config'> & { purpose?: string }) {
  const configKey = (purpose && PURPOSE_CONFIG_KEY[purpose]) || 'image'
  const config = NODE_DEFAULTS[configKey] || NODE_DEFAULTS.image
  const requirements = (purpose && PURPOSE_REQUIREMENTS[purpose]) || PURPOSE_REQUIREMENTS.create
  return <BaseNode {...props} config={config} {...requirements} />
}
